import { createReducer, updateItemInArray, updateObject } from 'helpers/ReducerUtil'
import {
  UPDATE_POWER_COMPONENTS,
  REMOVE_POWER_COMPONENTS,
  ADD_POWER_COMPONENTS,
} from './constants'

const addValue = (values, {railType}) => {
  return [...values, {railType: railType, componentType: '', componentPart: '', componentDetails: ''}]
}

const removeValue = (values, { index, railType }) => {
  let currIndex = 0
  return values.filter(component => {
    let componentValid = true
    if (component.railType == railType) {
      componentValid = (index !== currIndex)
      currIndex += 1
    }
    return componentValid
  })
}

const updateValue = (values, { index, inputType, powerComponentValue, railType }) => {
  let currIndex = 0
  return values.map(component => {
    if (component.railType === railType) {
      if (index === currIndex) component[inputType] = powerComponentValue
      currIndex += 1
    } 
    return component
  })
}

const powerComponentsReducer = createReducer([], {
  [ADD_POWER_COMPONENTS]: addValue,
  [REMOVE_POWER_COMPONENTS]: removeValue,
  [UPDATE_POWER_COMPONENTS]: updateValue
})

export default powerComponentsReducer
